import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html'
})
export class CheckboxComponent implements OnInit {
  checkboxNgModel = '';
  checkboxNgModelError = 'TestValue';

  form!: FormGroup;
  formButton!: FormGroup;
  submitted = false;
  isBrowser = true;

  Data: Array<any> = [
    { name: 'Pear', value: 'pear' },
    { name: 'Plum', value: 'plum' },
    { name: 'Kiwi', value: 'kiwi' },
    { name: 'Apple', value: 'apple' },
    { name: 'Lime', value: 'lime' },
  ];

  Data2: Array<any> = [
    { name: 'Pear1', value: 'pear1' },
    { name: 'Plum1', value: 'plum1' },
    { name: 'Kiwi1', value: 'kiwi1' },
    { name: 'Apple1', value: 'apple1' },
    { name: 'Lime1', value: 'lime1' },
  ];

  buttonStyle: Array<any> = [
    { add: 'Add', value: 'Add1' }    
  ];
  ariaLabel: string='Add';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([], [Validators.required])
    });
    this.formButton = this.formBuilder.group({
      checkButtonArray: this.formBuilder.array([], [Validators.required])
    });
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(param => {
      if (param['checkboxNgModel']) {
        this.checkboxNgModel = param['checkboxNgModel'];
      }
    });
  }

  onCheckboxChange(e: any) {
    const checkArray: FormArray = this.form.get('checkArray') as FormArray;
    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  onButtonCheckboxChange(e: any,inx:number) {
    const checkButtonArray: FormArray = this.formButton.get('checkButtonArray') as FormArray;
    if (e.target.checked) {
      checkButtonArray.push(new FormControl(e.target.value));
      this.ariaLabel='Add'
    }else{
      this.ariaLabel='remove'

    }
  }
}